import { render, staticRenderFns } from "./courseActivity.vue?vue&type=template&id=502c2ccc&scoped=true&"
import script from "./courseActivity.vue?vue&type=script&lang=js&"
export * from "./courseActivity.vue?vue&type=script&lang=js&"
import style0 from "./courseActivity.vue?vue&type=style&index=0&id=502c2ccc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502c2ccc",
  null
  
)

export default component.exports